export default "__VITE_ASSET__CbJGGPZL__"